import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface ICredit {
  remainingCreditsMonth: number | null;
  sentEssaysMonth: number | null;
  sentEssays: number | null;
}

interface MeState {
  credits: ICredit | null;
  setCredits: (credit: ICredit) => void;
  resetCredits: () => void;
}

export const meEssayStore = create<MeState>()(persist(
    (set) => ({
      credits: null,
      setCredits: (credit: ICredit) => set({ credits: credit }),
      resetCredits: () => set({ credits: null })
    }),
    {
      name: 'essay-me'
    }
  )
);
